import { Link } from "react-router-dom";

export const FAQ_CONTENT = {
  users: [
    {
      title: "What is Plaintr and how does it work?",
      content: (
        <>
          <p>
            Plaintr was built for people whose lives don’t fit into forms. We
            start with your story — what you do, how you earn, what changed this
            year — and from there, our Smart Match system connects you with a
            certified expert who fits your exact situation., Every match is
            personal. Every fee is upfront. Every payment is protected through a
            secure payment hold powered by Stripe, one of the most trusted
            payment platforms in the world., No mystery quotes. No hidden
            add-ons. Just a clear, human process designed to take the fear out
            of filing — and bring confidence back in.
          </p>
          <Link className="cta-button primary" to="/sign-up">
            Lets File
          </Link>
        </>
      ),
    },
    {
      title: "Who are the professionals working with Plaintr?",
      content: (
        <>
          <p>
            Only the best kind — the ones who earned it. Every professional on
            Plaintr is a Certified Public Accountant (CPA), Enrolled Agent (EA),
            or Tax Attorney. We personally verify their credentials, licenses,
            and identities before they join. No gig workers. No seasonal hires.
            Just credentialed experts who understand the tax code — and the
            people behind it. When you file through Plaintr, you’re not talking
            to a bot or an anonymous help desk. You’re matched with a real human
            who knows how to translate your life into a confident, accurate
            return.
          </p>
        </>
      ),
    },
    {
      title: "How do payments work — and why do we charge upfront?",
      content: (
        <>
          <p>
            Because clarity is trust. At Plaintr, you know exactly what you’ll
            pay — before you start. Your personalized flat fee is created for
            your specific case once Smart Match pairs you with the right pro.
            Once you accept, your payment is placed under a secure payment hold
            through Stripe — safely held until your case is complete and you
            approve the work. That means your money is protected, and so is your
            professional’s time.", No surprise invoices. No fine print. Just
            fairness on both sides — so you can focus on getting your best
            refund with complete peace of mind. return.
          </p>
        </>
      ),
    },
    {
      title: "What makes Smart Match different from other tax platforms?",
      content: (
        <>
          <p>
            Most tax platforms start with forms. We start with your life. Smart
            Match isn’t a robot guessing who should handle your case — it’s a
            human-designed system that reads context, not just numbers. It looks
            at what really matters: your income type, family situation, filing
            history, and even your goals for the year. Then it pairs you with a
            certified professional who fits that reality — not just someone
            available. You don’t have to scroll through profiles or wonder who
            to trust. Smart Match finds the right expert for you — fast, secure,
            and human.
          </p>
        </>
      ),
    },
    {
      title: "How does Smart Match connect me with a professional?",
      content: (
        <>
          <p>
            Smart Match turns your tax life into a clear, personal plan. Once
            you share your details, we calculate a personalized flat fee based
            on your full situation — no estimates, no surprises. When you
            accept, we connect you with a certified professional — a CPA,
            Enrolled Agent, or Tax Attorney — who fits your exact case. They
            handle everything from there, with one goal: accuracy, peace of
            mind, and the highest refund you deserve.
          </p>
        </>
      ),
    },
    {
      title: "What if my situation changes after I start filing?",
      content: (
        <>
          <p>
            Your flat fee is built around the situation you shared during Smart
            Match. If everything stays the same, your price never changes —
            guaranteed. If your tax life evolves later (say you add a new state
            or income type), your professional will simply update your case and
            adjust your plan accordingly. It’s always transparent, always
            upfront — and always in your control.
          </p>
        </>
      ),
    },
    {
      title: "Is my information safe with Plaintr?",
      content: (
        <>
          <p>
            Absolutely. Your data and your payments are protected at every step.
            We use bank-level encryption, store nothing unprotected, and process
            all payments through Stripe, a global leader in financial security.
            Plaintr never sells, shares, or reuses your information. Your
            records stay private, encrypted, and in your control — always.
          </p>
        </>
      ),
    },
    {
      title: "What if I’m self-employed or have a business?",
      content: (
        <>
          <p>
            You’re in the right place. Plaintr was built for all kinds of
            taxpayers — from freelancers and gig workers to LLC owners and
            full-time employees. When you describe your work, Smart Match
            identifies a pro who specializes in your exact kind of filing. That
            means your accountant understands not only the tax code — but also
            your industry. You’ll get human guidance for complex topics like
            deductions, write-offs, and quarterly estimates — without paying
            corporate rates.
          </p>
        </>
      ),
    },
    {
      title: "What happens after I file?",
      content: (
        <>
          <p>
            Once your professional finishes your case, you’ll review everything
            before it’s submitted. When you approve, the payment held under a
            secure payment hold through Stripe is released to your pro. You’ll
            receive confirmation, final documents, and ongoing support if you
            ever need to amend or check your filing status. It’s calm, clear,
            and transparent — just how it should be.
          </p>
        </>
      ),
    },
  ],
  experts: [
    {
      title: "What is Plaintr for professionals?",
      content: (
        <>
          <p>
            Plaintr is where certified experts finally get the kind of platform
            they deserve. We built it for CPAs, EAs, and Tax Attorneys who are
            tired of chaotic marketplaces and endless billing chases. Here,
            Smart Match brings you clients who need your specific expertise —
            not random leads. You see every case and fee upfront, decide whether
            to accept, and get paid through Stripe once the client confirms
            completion and the payment is released from the secure payment hold.
            No cold outreach. No race to the bottom. Just meaningful work, fair
            pay, and clients that respect what you do.
          </p>
          <p>Bring your expertise to Plaintr →</p>
          <Link className="cta-button primary" to="/create-cpa">
            Join as a Pro
          </Link>
        </>
      ),
    },
    {
      title: "Who can join Plaintr?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Plaintr is selective — and proudly so. We only accept licensed
              CPAs, Enrolled Agents, and Tax Attorneys who meet our standards of
              professionalism, accuracy, and integrity. Each applicant goes
              through:
            </p>
            <ul>
              <li>License verification with issuing boards</li>
              <li>Identity confirmation for security and compliance</li>
              <li>Knowledge assessment to ensure they’re truly experts</li>
            </ul>
            <p>
              If you’ve built your career on trust and quality, Plaintr is where
              that earns value. It’s not another gig app — it’s a network built
              for professionals who want freedom without friction.
            </p>
            <p>Ready to join? → </p>
            <Link className="cta-button primary" to="/create-cpa">
              Become a Plaintr Pro
            </Link>
          </div>
        </>
      ),
    },
    {
      title: "How does Smart Match work for professionals?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Smart Match isn’t lead generation — it’s alignment. We pair you
              with clients whose needs match your credentials, experience, and
              preferred case types. No bidding. No random leads. No wasted time.
              You receive curated cases that actually fit your expertise —
              because when both sides align, everyone wins.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "How do payments work?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Every client’s payment is securely held in Stripe. Once you
              complete the work and the client confirms delivery, Stripe
              releases your funds instantly. This system protects both you and
              your client — no disputes, no chasing payments, no middlemen. You
              focus on your work. We handle the trust.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "Can I set my own availability or decline cases?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Yes. Plaintr was built around professional freedom. You decide
              when you’re available, how many cases you take, and which clients
              fit your schedule or specialty. Smart Match sends you new cases,
              but you always choose what to accept — no penalties, no pressure.
              You’re in full control of your workload.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "Do I have to handle client billing or support?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              No — Plaintr handles that for you. You focus on providing quality
              work, while our system manages payment collection and client
              communication. Clients reach you through Plaintr’s platform, but
              our support team handles billing or process questions, so you
              never waste hours managing admin. It’s like having your own
              operations team — without the overhead.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "What kind of clients will I get?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              The kind that respects your time and expertise. Our clients aren’t
              random users — they’re verified individuals, freelancers, and
              small business owners looking for certified help. They come
              through Smart Match, not open sign-ups, so every connection is
              intentional. That means fewer mismatched expectations and more
              meaningful, well-paid work.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "How does Plaintr protect my professional reputation?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Your reputation is your currency — and we treat it that way.
              Plaintr combines verification, a secure payment hold, and
              structured feedback to protect both professionals and clients. If
              any issue arises, our support and moderation team reviews it
              carefully to ensure fairness and professionalism. We built this
              platform to elevate experts — not exploit them.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "How does onboarding work for new professionals?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Joining Plaintr is simple, but selective. After submitting your
              application, we verify your license, confirm your identity, and
              review your experience. You’ll then complete a short onboarding
              session where you set your expertise categories, communication
              preferences, and pricing tiers. Once approved, Smart Match starts
              sending you qualified cases. We keep it fast, human, and
              transparent — because your time deserves that respect.
            </p>
            <p>Learn more → </p>
            <Link to="/create-cpa" className="cta-button primary">
              Join as a Pro
            </Link>
          </div>
        </>
      ),
    },
  ],
  affiliates: [
    {
      title: "What is the Plaintr Affiliate Program?",
      content: (
        <>
          <p>
            The Plaintr Affiliate Program allows you to earn by sharing
            financial services your audience can trust.
          </p>
          <p>
            You introduce people to Plaintr through your unique link. When they
            take action — such as using a service or engaging with the platform
            — you generate earnings.
          </p>
          <p>It’s a system built around real usage, not just traffic.</p>
        </>
      ),
    },
    {
      title: "How do I earn as an affiliate?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              You earn when people from your network take meaningful actions
              through your link.
            </p>
            <p>This can include:</p>
            <ul>
              <li>Completing services</li>
              <li>Creating an account</li>
              <li>Engaging with content or features</li>
            </ul>
            <p>
              Your earnings are tied to real activity, which means your income
              grows as your network engages more deeply with Plaintr.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "What counts as a conversion?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              A conversion happens when someone from your network completes a
              tracked action through your link.
            </p>
            <p>Depending on the service or feature, this can include:</p>
            <ul>
              <li>Completing a financial service</li>
              <li>Creating and maintaining an account</li>
              <li>Engaging with promoted content</li>
            </ul>
            <p>
              All conversions are automatically tracked inside your dashboard.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "How much can I earn?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>Earnings vary depending on the type of action and service.</p>
            <p>For example:</p>
            <ul>
              <li>
                Some services reward a percentage of revenue generated through
                your referrals
              </li>
              <li>
                Others may generate earnings based on account activity over time
              </li>
              <li>Content promotion may reward based on qualified traffic</li>
            </ul>
            <p>
              Your dashboard shows exactly how your earnings are calculated and
              how they grow over time.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "Can I earn from the same user more than once?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>Yes.</p>
            <p>
              In some cases, your earnings are not limited to a single action.
              This means you can continue earning as users you referred:
            </p>
            <ul>
              <li>Use additional services</li>
              <li>Stay active on the platform</li>
              <li>Engage with new features</li>
            </ul>
            <p>
              This depends on how the user engages with the platform, and
              everything is tracked inside your dashboard.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "Do I need to sell or convince people?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>No.</p>
            <p>This is not a traditional sales model.</p>
            <p>
              You are not expected to push or pressure. Your role is to connect
              people to services that are genuinely useful.
            </p>
            <p>The platform handles the experience, tracking, and payouts.</p>
          </div>
        </>
      ),
    },
    {
      title: "How do I track my performance?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              You’ll have access to a dedicated dashboard where you can track:
            </p>
            <ul>
              <li>Link activity</li>
              <li>Conversions</li>
              <li>Earnings</li>
              <li>Payout status</li>
            </ul>
            <p>
              Everything is updated automatically, so you always have full
              visibility into your performance.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "When and how do I get paid?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>Payouts are processed through Stripe Connect.</p>
            <ul>
              <li>Earnings are verified before payout</li>
              <li>Payments are released on a regular schedule</li>
              <li>You’ll receive notifications when payouts are processed</li>
            </ul>
            <p>Stripe also handles tax documentation where applicable.</p>
          </div>
        </>
      ),
    },
    {
      title: "What kind of audience works best?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>Any audience that makes financial decisions.</p>
            <p>This includes:</p>
            <ul>
              <li>Individuals managing their personal finances</li>
              <li>Professionals navigating complex situations</li>
              <li>Communities interested in money, work, or growth</li>
            </ul>
            <p>
              If your audience trusts your recommendations, the program can
              work.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "Can I promote Plaintr in any way I want?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              You can share your link across your content and platforms, as long
              as it follows our guidelines.
            </p>
            <ul>
              <li>Organic content is allowed (posts, videos, blogs, etc.)</li>
              <li>
                Paid advertising may be restricted depending on compliance rules
              </li>
              <li>All partnerships must be disclosed clearly</li>
            </ul>
            <p>
              Detailed guidelines are available inside the Affiliate Help
              Center.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "What happens if a user cancels or requests a refund?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              If a transaction is reversed, the associated earnings may also be
              adjusted.
            </p>
            <p>You’ll see any changes reflected directly in your dashboard.</p>
          </div>
        </>
      ),
    },
    {
      title: "Is this only for tax filing?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>No.</p>
            <p>
              Tax filing is one of the services available today, but Plaintr is
              building a broader financial platform.
            </p>
            <p>
              As new services are introduced, your opportunities to earn expand
              as well.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "Do I need to be a financial expert to join?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>No.</p>
            <p>You don’t need to be an expert in taxes or finance.</p>
            <p>
              What matters is your ability to connect people to something
              valuable and trustworthy.
            </p>
          </div>
        </>
      ),
    },
    {
      title: "How do I get started?",
      content: (
        <>
          <div className="general-accordion-content-block">
            <p>
              Create an account, apply to the program and wait for approval.
            </p>
            <p>Once approved:</p>
            <ul>
              <li>You’ll receive access to your dashboard</li>
              <li>You can generate your affiliate link</li>
              <li>You can start sharing immediately</li>
            </ul>
          </div>
        </>
      ),
    },
  ],
};
